import {Injectable} from '@angular/core';
import {FlowlineCreateCommand} from './flowline.create.command';
import {DiagramUpdateService} from '../../diagram-data/diagram-update.service';
import {ShapeSpawnerService} from '../../diagram-render/shapes/shape-spawner.service';
import {EditorRegistryService} from '../../diagram-render/mx-graph/editor/editor-registry.service';
import {GraphHelperService} from '../../diagram-render/helpers/graph-helper.service';
import {StylesService} from '../../diagram-render/styles/styles.service';
import {FlowlineDeleteCommand} from './flowline.delete.command';
import {FlowlineChangeStyleCommand} from './flowline.changestyle.command';
import {DiagramJsonHandlerService} from '../../diagram-data/diagram-json-handler.service';
import {FlowlineChangeformCommand} from './flowline.changeform.command';
import {FlowlineAddLineTextCommand} from './linetext/flowline.addlinetext.command';
import {FlowlineDeleteLineTextCommand} from './linetext/flowline.deletelinetext.command';
import {FlowlineAddInteractionCommand} from './interaction/flowline.addinteraction.command';
import {FlowlineDeleteInteractionCommand} from './interaction/flowline.deleteinteraction.command';
import {FlowlineReorderInteractionCommand} from './interaction/flowline.reoderinteraction.command';
import {FlowlineChangeInteractionDescriptionCommand} from './interaction/flowline.changeinteractiondescription.command';
import {FlowlineChangeInteractionStyleCommand} from './interaction/flowline.changeinteractionstyle.command';
import {DiagramTypeConfigService} from '../../core/services/diagram-type-config.service';

@Injectable()
export class FlowlineCommands {
  private serviceObj: object;

  constructor(
    diagramUpdateSvc: DiagramUpdateService,
    shapeSpawnerSvc: ShapeSpawnerService,
    editorRegistrySvc: EditorRegistryService,
    graphHelperSvc: GraphHelperService,
    stylesSvc: StylesService,
    jsonHandlerSvc: DiagramJsonHandlerService,
    diagramTypeConfigSvc: DiagramTypeConfigService
  ) {
    this.serviceObj = {
      diagramUpdateSvc,
      shapeSpawnerSvc,
      editorRegistrySvc,
      graphHelperSvc,
      stylesSvc,
      jsonHandlerSvc,
      diagramTypeConfigSvc
    };
  }

  public create(data, firstActionSkip: boolean = false) {
    return new FlowlineCreateCommand({data, firstAction: firstActionSkip}).injectServices(
      this.serviceObj
    );
  }

  public delete(data) {
    return new FlowlineDeleteCommand(data).injectServices(this.serviceObj);
  }

  public changeStyle(mxKey: number, style: any, customStyle: boolean) {
    return new FlowlineChangeStyleCommand({mxKey, style, customStyle})
      .injectServices(this.serviceObj)
      .prepareData();
  }

  public changeForm(data, formData) {
    return new FlowlineChangeformCommand(data)
      .injectServices(this.serviceObj)
      .prepareData(formData);
  }

  public addLineText(data) {
    return new FlowlineAddLineTextCommand(data).injectServices(this.serviceObj);
  }

  public deleteLineText(data) {
    return new FlowlineDeleteLineTextCommand(data).injectServices(this.serviceObj);
  }

  public addInteraction(data) {
    return new FlowlineAddInteractionCommand(data).injectServices(this.serviceObj);
  }

  public deleteInteraction(data) {
    return new FlowlineDeleteInteractionCommand(data).injectServices(this.serviceObj);
  }

  public reorderInteraction(data) {
    return new FlowlineReorderInteractionCommand(data).injectServices(this.serviceObj);
  }

  public changeInteractionDescription(data) {
    return new FlowlineChangeInteractionDescriptionCommand(data).injectServices(this.serviceObj);
  }

  public changeInteractionStyle(data) {
    return new FlowlineChangeInteractionStyleCommand(data).injectServices(this.serviceObj);
  }
}

export interface FlForm {
  end: string;
  shape: string;
  start: string;
  type: string;
  resetPoints: boolean;
}

export interface FormUnit {
  icon: string;
  props: Array<{key: string; val: string}>;
  title: string;
  tooltip: string;
}
